<template>
  <b-row class="my-3">
    <b-col>
      <b-card bg-variant="light">
        <b-row>
          <b-col>
            <h6 class="text-info">{{ $t("globals.notes") }}:</h6>
          </b-col>
          <b-col>
            <b-btn
              v-if="!edit && service.status == 'created'"
              class="float-right m-1"
              variant="info"
              size="sm"
              @click="edit = true"
            >
              {{ $t("globals.edit") }}
            </b-btn>
            <b-btn
              v-if="edit"
              class="float-right m-1"
              variant="success"
              size="sm"
              @click="saveEdit"
            >
              {{ $t("globals.save") }}
            </b-btn>
            <b-btn
              v-if="edit"
              class="float-right m-1"
              variant="info"
              size="sm"
              @click="cancelEdit"
            >
              {{ $t("globals.cancel") }}
            </b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-textarea v-model="service.notes" rows="2" :disabled="!edit">
            </b-form-textarea>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    refresh: Function,
    service: {
      type: Object,
      default: () => ({
        id: 0,
        status: "created",
        notes: ""
      })
    }
  },
  data() {
    return {
      edit: false
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    cancelEdit() {
      this.edit = false;
      this.refresh();
    },
    saveEdit() {
      const data = {
        query: `
          mutation {
            res: ServiceEditNotes (
              service_id: ${this.service.id},
              notes: "${this.service.notes}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.edit = false;
        this.refresh();
      });
    },
  }
};
</script>
